import "core-js/es6/promise";
import "core-js/es6/string";
import "core-js/es7/array";
import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import App from "./App";
import router from "./router";
import axios from "axios";
import store from "./store";
import helper from "./helper";
import Multiselect from "vue-multiselect";
import "@/assets/css/multiselect-bs4.css";
import Vuex from "vuex";

/// ===== LOCAL DEV
// const BASE_API_PATH = "http://sm.api.com/api/"
// const BASE_FILE_PATH = "http://sm.api.com"

/// ===== PRODUCTION
// const BASE_API_PATH = "https://ignis.penjualan.pugindo.com/api/";
// const BASE_API_PATH_ECOMM = "";
// const BASE_FILE_PATH = "https://cdn-sm.do.pgindonesia.com";
// const BASE_PRINT_FILE_PATH = "https://ignis.penjualan.pugindo.com";
// const BASE_UPLOAD_PATH = "https://file-upload.penjualan.pugindo.com/api/v1/file-upload"

const BASE_API_PATH = "https://api-penjualan.sinarmutiaracell.com/api/";
const BASE_API_PATH_ECOMM = "";
const BASE_FILE_PATH = "https://cdn-sm.do.pgindonesia.com";
const BASE_PRINT_FILE_PATH = "https://api-penjualan.sinarmutiaracell.com";
const BASE_UPLOAD_PATH = "https://file-upload.penjualan.pugindo.com/api/v1/file-upload"


/// ===== LOCAL WANDY
// const BASE_API_PATH = "http://10.10.131.114:8000/api/"
// const BASE_API_PATH_ECOMM = "http://10.10.131.114:8000/api/"
// const BASE_FILE_PATH = "http://10.10.131.114:8000"
// const BASE_PRINT_FILE_PATH = "http://10.10.131.114:8000"

// ==== STAGGING
// const BASE_API_PATH = "https://api.sm-penjualan-stg.pgindonesia.com/api/";
// const BASE_API_PATH_ECOMM = "https://api.sm-penjualan-stg.pgindonesia.com/api/";
// const BASE_FILE_PATH = "https://sm-dev.sgp1.digitaloceanspaces.com";
// const BASE_PRINT_FILE_PATH = "https://api.sm-penjualan-stg.pgindonesia.com";
// const BASE_UPLOAD_PATH = "https://dev-sm-upload.pgindonesia.com/api/v1/file-upload"

// // ==== DEV
// const BASE_API_PATH = "https://api.sm-penjualan-dev.pgindonesia.com/api/";
// const BASE_API_PATH = "https://api-penjualan.sinarmutiaracell.com/api/";
// const BASE_API_PATH_ECOMM = "https://api.sm-penjualan-dev.pgindonesia.com/api/";
// const BASE_FILE_PATH = "https://sm-dev.sgp1.digitaloceanspaces.com";
// // const BASE_PRINT_FILE_PATH = "https://api.sm-penjualan-dev.pgindonesia.com";
// const BASE_PRINT_FILE_PATH = "https://api-penjualan.sinarmutiaracell.com";
// const BASE_UPLOAD_PATH = "https://dev-sm-upload.pgindonesia.com/api/v1/file-upload"

// const BASE_API_PATH = "http://localhost:8000/api/";
// const BASE_API_PATH_ECOMM = "http://localhost:8000/api/";
// const BASE_FILE_PATH = "http://localhost:8000";
// const BASE_PRINT_FILE_PATH = "http://localhost:8000";

var axiosPugindo = axios.create({
    baseURL: BASE_API_PATH
});
var axiosEcommerce = axios.create({
    baseURL: BASE_API_PATH_ECOMM
});

axiosPugindo.defaults.baseURL = BASE_API_PATH;
axiosPugindo.defaults.timeout = 180000;
axiosPugindo.defaults.headers.post["Accept"] = "application/json";
axiosPugindo.defaults.headers.common['Authorization'] = localStorage.getItem("token") || "";
// axiosPugindo.defaults.headers.common['LoginTime'] = store.state.loginTime || ""

axiosEcommerce.defaults.baseURL = BASE_API_PATH_ECOMM;
axiosEcommerce.defaults.timeout = 180000;
axiosEcommerce.defaults.headers.post["Accept"] = "application/json";
axiosEcommerce.defaults.headers.common["Authorization"] =
    localStorage.getItem("token") || "";
// axiosEcommerce.defaults.headers.common['LoginTime'] = localStorage.getItem("loginTime") || ""

// Interceptors for 401 responses (unauthorized)
axiosPugindo.interceptors.response.use(
    function(response) {
        return response;
    },
    function(error) {
        if (error.response && error.response.status == 401) {
            axiosPugindo.defaults.headers.common["Authorization"] = "";
            var version = localStorage.getItem("version");
            localStorage.clear();
            localStorage.setItem("version", version);

            router.push("/login");
        } else if (error.response && error.response.status == 402) {
            axiosPugindo.defaults.headers.common["Authorization"] = "";
            var version = localStorage.getItem("version");
            localStorage.clear();
            localStorage.setItem("version", version);

            router.push("/login?error=true");
        }

        return Promise.reject(error);
    }
);

// Interceptors for 401 responses (unauthorized)
axiosEcommerce.interceptors.response.use(
    function(response) {
        return response;
    },
    function(error) {
        console.log(error.response);

        if (error.response && error.response.status == 401) {
            axiosEcommerce.defaults.headers.common["Authorization"] = "";
            var version = localStorage.getItem("version");
            localStorage.clear();
            localStorage.setItem("version", version);

            router.push("/login");
        } else if (error.response && error.response.status == 402) {
            axiosEcommerce.defaults.headers.common["Authorization"] = "";
            var version = localStorage.getItem("version");
            localStorage.clear();
            localStorage.setItem("version", version);

            router.push("/login?error=true");
        }

        return Promise.reject(error);
    }
);

Vue.use(BootstrapVue);
Vue.component("multiselect", Multiselect);
Vue.prototype.$axios = axiosPugindo;
Vue.prototype.$axiosEC = axiosEcommerce;
Vue.prototype.$helper = helper;
Vue.prototype.$BASE_FILE_PATH = BASE_FILE_PATH;
Vue.prototype.$BASE_PRINT_FILE_PATH = BASE_PRINT_FILE_PATH;
Vue.prototype.$BASE_UPLOAD_PATH = BASE_UPLOAD_PATH;

/// GLOBAL COMPONENTS
/// Base components
const requireComponent = require.context(
    "./globals",
    false,
    /[A-Z]\w+\.(vue|js)$/
);

requireComponent.keys().forEach(fileName => {
    const componentConfig = requireComponent(fileName);
    let compName = fileName.includes("Loading") ? "LoadingWidget" : "PageSizer";

    Vue.component(compName, componentConfig.default || componentConfig);
});

new Vue({
    el: "#app",
    router,
    store,
    template: "<App/>",
    components: {
        App
    }
});
